import React, { useEffect, useState } from 'react';
import api from '../config/axios';
import stripePromise from '../config/stripeConfig';

interface User {
    userId: number;
    prenom: string;
    nom: string;
    email: string;
    civiliteId: number;
    handId: number;
    classement: number;
    departementId: number;
    niveauId: number;
    canBeSearched: boolean;
    dispoTournoi: boolean;
    dispoLibre: boolean;
}


const PremiumSection: React.FC = () => {

    const [user, setUser] = useState<User | null>(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [error, setError] = useState<string | null>(null);
    
    useEffect(() => {

        const fetchUserData = async () => {
            try {
                const token = sessionStorage.getItem('accessToken');

                if (!token) {
                    setError('Token non trouvé');                    
                    return;
                }

                const response = await api.get('/users/me');
                // Take first item from array
                const userData = response.data;
                setIsLoggedIn(!!token);

                if (userData) {
                    setUser(userData);
                } else {
                    setError('Aucune donnée utilisateur trouvée');
                }
                

            } catch (error) {
                console.error('Erreur lors du chargement des données utilisateur:', error);
                setError('Erreur lors du chargement des données');            
            }
        };

        fetchUserData();
    }, []);

    const handleSubscribe = async () => {
        const stripe = await stripePromise;
    
        try {
          // Appel au backend pour créer une session Checkout
          const response = await api.post('/stripe/create-checkout-session', {
            priceId: process.env.REACT_APP_PRICE_ID_MONTHLY, // Remplacez par le Price ID réel
            userId: user?.userId, // Identifiant de l'utilisateur connecté
          });
    
          console.log('Session créée:', response.data);

          const sessionId = response.data.id;
    
          // Redirige l'utilisateur vers Stripe Checkout
          const { error } = await stripe!.redirectToCheckout({ sessionId });
    
          if (error) {
            console.error('Erreur lors de la redirection vers Stripe :', error.message);
          }
        } catch (err) {
          console.error('Erreur lors de la création de la session :', err instanceof Error ? err.message : 'Une erreur est survenue');
        }
      };

  return (
    <>
    <section className="py-8 bg-orange-300 text-white">
    <div className="container mx-auto px-4 text-center">
      <h2 className="text-3xl font-bold mb-4">Rejoignez TournoisPadel</h2>      
        <p className="text-lg mb-8">Accédez à une plateforme dédiée aux passionnés de padel.</p>
    </div>
  </section>
    <div className="font-[sans-serif] p-4  rounded-lg">
            <div className="max-w-5xl max-lg:max-w-2xl mx-auto">
                <div className="text-center">
                <h2 className="text-gray-800 text-xl font-bold mb-4">En créant un compte, vous pourrez :</h2>                
                </div>

                <div className="grid grid-cols-1 gap-6 mt-10 max-sm:max-w-sm max-sm:mx-auto">
                <div className="border rounded-md p-6">

                    <div className="mt-6">                    
                    <p className="text-sm text-gray-500"></p>

                    <ul className="mt-6 space-y-4">
                        <li className="flex items-start text-sm text-gray-500">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" className="mr-3 fill-green-500" viewBox="0 0 24 24">
                                <path d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z" data-original="#000000" />
                            </svg>
                            <div>
                                <span className="font-semibold">Accès détaillé aux tournois</span>
                                <br /> 
                                Découvrez toutes les informations nécessaires pour vous inscrire facilement (lien d'inscription, lieux précis, coordonnées des organisateurs).
                            </div>
                        </li>                        
                        <li className="flex items-start text-sm text-gray-500">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" className="mr-3 fill-green-500" viewBox="0 0 24 24">
                                <path d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z" data-original="#000000" />
                            </svg>
                            <div>
                                <span className="font-semibold">Informations générales</span>
                                <br />
                                Retrouvez toutes les informations du club organisateur ainsi que les modalités d'inscriptions.
                            </div>
                        </li>
                        <li className="flex items-start text-sm text-gray-500">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" className="mr-3 fill-green-500" viewBox="0 0 24 24">
                            <path d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z" data-original="#000000" />
                        </svg>
                            <div>
                                <span className="font-semibold">Notifications personnalisées</span>
                                <br /> 
                                Recevez des alertes instantanées dès qu’un nouveau tournoi est annoncé dans votre région ou selon vos critères (niveau, type de tournoi).
                            </div>
                        </li>
                        <li className="flex items-start text-sm text-gray-500">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" className="mr-3 fill-green-500" viewBox="0 0 24 24">
                            <path d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z" data-original="#000000" />
                        </svg>
                            <div>
                                <span className="font-semibold">Mise en relation avancée</span>
                                <br /> 
                                Envoyez et recevez des messages privés directement sur la plateforme pour organiser vos matchs ou trouver un partenaire pour participer à des tournois
                            </div>
                        </li>
                        <li className="flex items-start text-sm text-gray-500">
                        
                            </li>
                    </ul>    
                    <div className='text-center'>
                            {isLoggedIn ? (
                                <button  onClick={handleSubscribe} type="button" className="w-full mt-6 px-4 py-2 text-sm  text-white bg-orange-600 hover:bg-orange-400 rounded-md">S'abonner</button>
                            ) : (
                                <a href="/signup" className="w-full mt-6 px-4 py-2 text-sm text-white bg-orange-300 hover:bg-orange-400 rounded-md">
                                Créer un compte pour s'abonner
                                </a>
                            )}
                            </div>                
                    </div>
                </div>
                             
                </div>
            </div>
            </div>  </>
  );
};

export default PremiumSection;